import React, { useState, useEffect } from "react";
import { Trash2, GripVertical } from "lucide-react";

const move = (arr, from, to) => {
  const a = [...arr];
  const [x] = a.splice(from, 1);
  a.splice(to, 0, x);
  return a;
};

// Sürükle-bırak ile sıralanabilen fotoğraf ızgarası; ilk fotoğraf kapaktır.
const CaptionInput = ({ value, onSave, testid }) => {
  const [v, setV] = useState(value || "");
  useEffect(() => setV(value || ""), [value]);
  const save = () => { if ((v || "").trim() !== (value || "")) onSave(v.trim()); };
  return (
    <input
      value={v}
      onChange={(e) => setV(e.target.value.slice(0, 60))}
      onBlur={save}
      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
      draggable={false}
      onDragStart={(e) => { e.preventDefault(); e.stopPropagation(); }}
      placeholder="Açıklama ekle (örn. Bahçe alanı)"
      data-testid={testid}
      className="w-full px-2 py-1.5 text-xs border-t border-[#F0DDE0] bg-white outline-none focus:bg-[#FBF5F0] placeholder:text-[#c4b7b9] cursor-text"
    />
  );
};

export const SortableGallery = ({ images, onDelete, onReorder, captions = {}, onCaption, testid = "gallery" }) => {
  const [order, setOrder] = useState(null);
  const [drag, setDrag] = useState(null);
  const idx = order || images.map((_, i) => i);

  const start = (i) => { setDrag(i); setOrder(images.map((_, k) => k)); };
  const over = (e, i) => {
    e.preventDefault();
    if (drag === null || drag === i) return;
    setOrder((o) => move(o, drag, i));
    setDrag(i);
  };
  const end = () => {
    const changed = order && order.some((v, k) => v !== k);
    if (changed) onReorder(order);
    setDrag(null); setOrder(null);
  };
  const nudge = (pos, dir) => {
    const to = pos + dir;
    if (to < 0 || to >= images.length) return;
    onReorder(move(images.map((_, k) => k), pos, to));
  };

  return (
    <div className="mt-4" data-testid={testid}>
      <p className="text-xs text-[#7C6E70] mb-2 flex items-center gap-1"><GripVertical className="w-3.5 h-3.5" /> Sırayı değiştirmek için fotoğrafları sürükleyip bırakın. İlk fotoğraf kapak olur. Altına kısa açıklama yazabilirsiniz.</p>
      <div className="grid grid-cols-2 gap-3">
        {idx.map((orig, pos) => (
          <div
            key={images[orig]}
            draggable
            onDragStart={() => start(pos)}
            onDragOver={(e) => over(e, pos)}
            onDrop={(e) => e.preventDefault()}
            onDragEnd={end}
            data-testid={`${testid}-item-${pos}`}
            className={`relative group rounded-xl overflow-hidden border cursor-grab active:cursor-grabbing transition-[opacity,transform,border-color] duration-150 ${drag === pos ? "opacity-40 scale-95 border-[#C15B6B]" : "border-[#F0DDE0]"}`}
          >
            <img src={images[orig]} alt={`Foto ${pos + 1}`} draggable={false} className="w-full h-24 object-cover pointer-events-none select-none" />
            {pos === 0 && <span className="absolute top-1 left-1 px-2 py-0.5 rounded-full bg-[#C6A15B] text-white text-[10px]">Kapak</span>}
            <span className="absolute bottom-1 left-1 w-6 h-6 rounded-full bg-black/55 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><GripVertical className="w-3.5 h-3.5" /></span>
            <div className="absolute bottom-1 right-1 flex gap-1 sm:hidden">
              <button onClick={() => nudge(pos, -1)} disabled={pos === 0} className="w-6 h-6 rounded-full bg-black/55 text-white text-xs disabled:opacity-30" aria-label="Öne al" data-testid={`${testid}-up-${pos}`}>←</button>
              <button onClick={() => nudge(pos, 1)} disabled={pos === images.length - 1} className="w-6 h-6 rounded-full bg-black/55 text-white text-xs disabled:opacity-30" aria-label="Geriye al" data-testid={`${testid}-down-${pos}`}>→</button>
            </div>
            {onCaption && <CaptionInput value={(captions || {})[images[orig]]} onSave={(t) => onCaption(images[orig], t)} testid={`${testid}-caption-${pos}`} />}
            <button
              onClick={() => onDelete(orig)}
              className="absolute top-1 right-1 w-6 h-6 rounded-full bg-black/55 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
              aria-label="Sil"
              data-testid={`${testid}-delete-${pos}`}
            >
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
